var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-content"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:[_vm.active === index ? 'active' : 'default', 'step-item']},[_c('img',{attrs:{"src":_vm.logo(step, index)}}),_c('div',[_vm._v(_vm._s(step.title))]),(index < _vm.steps.length - 1)?_c('div',{staticClass:"step-line"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }